import type { ButtonName } from '@coursera/event-pulse-types';

type PeerEventingButtonName = Extract<
  ButtonName,
  | 'peer_review_submit_feedback'
  | 'peer_review_start_reviewing'
  | 'peer_review_start_new_attempt'
  | 'peer_review_submit_assignment'
>;

export const ButtonNames = {
  SUBMIT_FEEDBACK: 'peer_review_submit_feedback' as PeerEventingButtonName,
  START_REVIEWING: 'peer_review_start_reviewing' as PeerEventingButtonName,
  START_NEW_ATTEMPT: 'peer_review_start_new_attempt' as PeerEventingButtonName,
  SUBMIT_ASSIGNMENT: 'peer_review_submit_assignment' as PeerEventingButtonName,
} as const;
